export default __webpack_public_path__ + "static/media/4.cbd29612.png";